/**
 * Production-safe logger utility
 * Logs are disabled in production to prevent exposing sensitive information
 */
/* eslint-disable no-console */
const isDevelopment = process.env.NODE_ENV === 'development';

// Sanitize sensitive data from logs
const sanitizeData = (data) => {
  if (!data || typeof data !== 'object') {
    return data;
  }
  
  const sensitiveKeys = ['id', 'user_id', 'userId', 'user', 'email', 'password', 'token', 'accessToken', 'refreshToken', 'access_token', 'refresh_token', 'credentials', 'phone_number', 'phone'];
  const sanitized = { ...data };
  
  for (const key of sensitiveKeys) {
    if (key in sanitized) {
      sanitized[key] = '[REDACTED]';
    }
  }
  
  return sanitized;
};

export const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  error: (...args) => {
    // Always log errors, but sanitize sensitive data
    if (isDevelopment) {
      console.error(...args);
    } else {
      // In production, sanitize sensitive data
      const sanitized = args.map(arg => {
        if (typeof arg === 'object' && arg !== null) {
          return sanitizeData(arg);
        }
        return arg;
      });
      console.error(...sanitized);
    }
  },
  
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
};

